/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ForcSurveyBasedComponent from "core/components/forc/abstract/survey-based-component";
export default class LifestyleEditionComponent extends ForcSurveyBasedComponent {
  get validations() {
    return {};
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (!model.children) {
      model.children = [{}];
    }
    if (!model.siblings) {
      model.siblings = [{}];
    }
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    // Remove empty chilren and siblings. This can happend in two ways:
    // - there is one child and sibling added at the initialization of the form,
    // - when adding new item, the content is not mandatory, users may not fill
    // content.
    payload.children = payload.children ? payload.children.filter(this._childIsPresent) : [];
    payload.siblings = payload.siblings ? payload.siblings.filter(this._childIsPresent) : [];
    if (!["activeFullTime", "activePartTime"].includes(payload.professionalActivity)) {
      delete payload.job;
      delete payload.jobProtectedZone;
      delete payload.jobSickLeaveRelated;
    }
    if (!["unemployed"].includes(payload.professionalActivity)) {
      delete payload.jobLastEmployment;
    }
    if (payload.jobSickLeaveRelated == "no") {
      delete payload.jobSickLeaveDuration;
    }
    if (payload.hasChildren == "no") {
      delete payload.children;
    }
    if (payload.hasSiblings == "no") {
      delete payload.siblings;
    }
    return payload;
  }
  _childIsPresent(child) {
    return child.gender || child.birthyear || child.city;
  }
}
_defineProperty(LifestyleEditionComponent, "fullComponentId", "lifestyle/edition");
_defineProperty(LifestyleEditionComponent, "forcDisplayName", "Mode de vie, situation sociale");